import { render, staticRenderFns } from "./ClassView.vue?vue&type=template&id=7f67020a&"
import script from "./ClassView.vue?vue&type=script&lang=js&"
export * from "./ClassView.vue?vue&type=script&lang=js&"
import style0 from "./ClassView.vue?vue&type=style&index=0&id=7f67020a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports